
import LayeredParallax from "@/components/base/LayeredParallax"
import { mapGetters } from "vuex"
import currentYearMixin from "@/mixins/currentYearMixin"
export default {
    name: "RegionHeader",
    components: { LayeredParallax },
    mixins: [currentYearMixin],
    data: () => ({
        parallaxLayers: [
            require("@/assets/images/fair/deggendorf/parallax/l6.svg"),
            require("@/assets/images/fair/deggendorf/parallax/l5.svg"),
            require("@/assets/images/fair/deggendorf/parallax/l4.svg"),
            require("@/assets/images/fair/deggendorf/parallax/l3.svg"),
            require("@/assets/images/fair/deggendorf/parallax/l1.svg"),
            require("@/assets/images/fair/deggendorf/parallax/l2.svg"),
        ],
        parallaxLayerTransforms: [1.6, 1.65, 1.7, 2, 2.05, 2.1],
    }),
    computed: {
        ...mapGetters("search", ["selectedCategory"]),
        parallaxHeight() {
            if (this.$breakpoint.smAndDown) return 380
            if (this.$breakpoint.lgAndDown) return 600
            return 700
        },
        isOverviewPage() {
            return this.selectedCategory == "Alles"
        },
        seoHeadline() {
            switch (this.selectedCategory) {
                case "Unternehmen":
                    return `<strong>Ausbildungsbetriebe</strong> <br /> <strong>Deggendorf</strong> ${this.targetYear}`
                case "Praktikum":
                    return `Freie <strong>Schülerpraktika</strong> <br /> <strong>Deggendorf</strong> ${this.targetYear}`
                case "Ausbildung":
                    return `Freie <strong>Ausbildungsstellen</strong> <br /> <strong>Deggendorf</strong> ${this.targetYear}`
                case "Neuigkeiten":
                    return `<strong>Neuigkeiten & Highlights</strong> <br /> <strong>Deggendorf</strong> ${this.targetYear}`
                default:
                    return `<span>Meine Zukunft</span><br /> <span class="headline-4"><strong>Deggendorf</strong></span><br />`
            }
        },
    },
}
